import { ApiUrl } from "../../../assets/data/TkApiUrlProperty";
import http from "../../../services/http";
import {
  IAPI_APP016_Request,
  IAPI_APP016_Response,
  IAPI_REC021_Request,
  IAPI_REC021_Response,
  IAPI_REC022_Request,
  IAPI_REC022_Response,
} from "../../../type/apiType";

// 振込情報申請参照API
// 仕様書_収納・納付請求処理
const httpAPI_REC021 = async (
  param: IAPI_REC021_Request
): Promise<IAPI_REC021_Response> => {
  let res = await http.post(ApiUrl.API_REC021, {
    ...param,
  });

  return res.data;
};

// 振込情報申請更新API
// 仕様書_収納・納付請求処理
const httpAPI_REC022 = async (
  param: IAPI_REC022_Request
): Promise<IAPI_REC022_Response> => {
  let res = await http.post(ApiUrl.API_REC022, {
    ...param,
  });

  return res.data;
};
// API仕様書_申請情報_申請状況更新
// 申請状況更新API
const httpAPI_APP016 = async (
  param: IAPI_APP016_Request
): Promise<IAPI_APP016_Response> => {
  let res = await http.post(ApiUrl.API_APP016, {
    ...param,
  });

  return res.data;
};

export { httpAPI_REC021, httpAPI_REC022, httpAPI_APP016 };
